import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./view.css";
import {
  faq_approve_status,
  faq_revert_status,
  get_faq_details,
  get_membership_details,
  membership_approve_status,
  membership_revert_status,
} from "../admin.api";
import Snackbar from "../../../components/snackbar/snackbar";
import ReactHtmlParser from "react-html-parser";
import Loader from "../../../components/loader/loader";
import jwtDecode from "jwt-decode";
import Swal from "sweetalert2";

export default function View(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [url, setUrl] = useState("");
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const selectedParam = useParams();
  const getDetails = (id) => {
    get_faq_details(id).then((res) => {
      let tdata = res.faq;
      setData(tdata);
      setIsActive(false);
    });
  };
  useEffect(() => {
    getDetails(selectedParam.id);
  }, []);
  const handleApproveStatus = (status) => {
    let data = { status: status };
    setIsActive(true);

    faq_approve_status(selectedParam.id, data)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const saMessage = (status) => {
    Swal.fire({
      title: "Message",
      input: "textarea",
      inputLabel: "Provide a reason",
      showCancelButton: true,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Please describe the reason";
        }
      },
    }).then((message) => {
      if (message.isConfirmed && message.value.trim()) {
        let rpdetails = data?.id;
        if (!rpdetails) {
          console.error("FAQ ID is missing.");
          setSnackMessage("Error: FAQ ID is missing.");
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }

        let rdata = { status_id: status, rp_id: rpdetails, revert_reason: message.value };

        if (adminType === 1) {
          rdata[status === 1 ? "admin_message" : "user_message"] = message.value;
        } else {
          rdata["super_admin_message"] = message.value;
        }

        setIsActive(true);

        faq_revert_status(rpdetails, rdata)
          .then((res) => {
            setSnackMessage(res?.message || "Action successful");
            setIsSnackError(false);
            setSnackOpen(true);
          })
          .catch((error) => {
            setSnackMessage(error.response?.data?.message || "Error processing request");
            setIsSnackError(true);
            setSnackOpen(true);
          })
          .finally(() => {
            setIsActive(false);
          });
      }
    });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/faq-list");
    }
  };
  return (
    <div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <span className="d-flex justify-content-between">
          <h6 className="mb-0 pt-2">
            <b>FAQ</b>
          </h6>

        </span>
        <hr />
        <button
          type="button"
          className="btn btn-primary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/faq-list");
          }}
        >
          Back
        </button>
        <div className="data">
          <div className="row">
            <div className="col-3">Question[English]</div>
            <div className="col-1">:</div>
            <div className="col-7">
               <div>{data?.question ? ReactHtmlParser(data?.question) : ""}</div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">Question[Malayalam]</div>
            <div className="col-1">:</div>
            <div className="col-7">
               <div>{data?.question_ma ? ReactHtmlParser(data?.question_ma) : ""}</div>
            </div>
          </div>

          <div className="row">
            <div className="col-3">Answer[English]</div>
            <div className="col-1">:</div>
            <div className="col-7">
              <div>{data?.answer ? ReactHtmlParser(data?.answer) : ""}</div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">Answer[Malayalam]</div>
            <div className="col-1">:</div>
            <div className="col-7">
              <div>{data?.answer_ma ? ReactHtmlParser(data?.answer_ma) : ""}</div>
            </div>
          </div>

          {data?.status !== 0 && data?.revert_reason !== '' &&
            <div className="data">
              <div className="row">
                <div className="col-3">Revert Reason</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {data?.revert_reason || "Not Available"}
                </div>
              </div>
            </div>
          }
          {adminType === 2 && data && data.status === 0 && (
            <div className="d-flex justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-approve btn-success mr-2"
                onClick={() => handleApproveStatus(1)}
              >
                Approve
              </button>
              <br />
              <button
                type="button"
                className="btn btn-reject btn-danger"
                onClick={() => saMessage(5)}
              >
                Revert
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
